<template>
    <div
        class="inline-button">
        <span> {{ label }} </span>
        
        <Icon :svg="icon" />
    </div>
</template>

<script>

import Icon from './Icon';

export default {
    name: 'InlineButton',

    components: {
        Icon
    },

    props: {
        icon: {
            type: String,
            required: true
        },

        label: {
            type: String,
            required: true
        }
    }
};
</script>

<style lang="less">

    @import "../styles/colors.less";

    .inline-button svg {
        fill: @inline-svg-grey;
    }
    
    .inline-button:hover {
        svg {
            fill: @color-pink-voluum;
        }

        span {
            color: @color-blue-light;
        }
    }
</style>

<style scoped lang="less">
    @import "../styles/colors.less";

    .inline-button {
        display: flex;
        align-items: center;

        vertical-align: middle;

        color: @inline-svg-grey;
    }

    .inline-button span {
        margin-right: 4px;
        display: block;
    }

</style>



// WEBPACK FOOTER //
// src/components/InlineButton.vue